import React from 'react';
import PropTypes from 'prop-types';
import './css/OrderStatusBadge.css';
import { getOrderStatusText } from '../../../Utils/CommonUtils';
import {
  STATUS_PREFIX,
  STATUS_HINT,
} from '../../../Utils/Constants/AdminConstants';

function OrderStatusBadge(props) {
  const { status } = props;

  return (
    <span
      className={`osb_badge osb_${(status || '').toLowerCase()}`}
      title={STATUS_HINT}
    >
      <span className="osb_prefix">{STATUS_PREFIX}</span>
      {getOrderStatusText(status) || status}
    </span>
  );
}

OrderStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default OrderStatusBadge;
